


















































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { UserInfo } from '../../_models/userInfo'

@Component
export default class DetailsUserInfoTab extends Vue {
  @Prop() info!: UserInfo;
  @Prop() userType!: string;
}
